import React from 'react'
import cls from './separator.module.scss'
import classnames from 'classnames'

const Separator = ({ className }) => {
  return <div className={classnames(cls.separator, className)} />
}

export default Separator
